import clsx from 'clsx';
import React from 'react';
import styles from './styles.module.css';
import baseStyles from '../../styles.module.css';

type Props = React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & {
  inputmode?: 'numeric';
  hasError?: boolean;
};

export const WisoryInput = React.forwardRef<HTMLInputElement, Props>(({ className, hasError, ...otherProps }, ref) => {
  return (
    <input
      ref={ref}
      className={clsx(baseStyles.baseWrapper, styles.input, className, { [styles.error]: hasError })}
      {...otherProps}
    />
  );
});

WisoryInput.displayName = 'WisoryInput';
